<!--
Created on 2021-04-13
Copyright (c) 2021 Vilten s.r.o. - All Rights Reserved
Unauthorized copying of this file, via any medium is strictly prohibited
Proprietary and confidential
Written by Viliam Tencer <vilten@vilten.sk>, 2021-04-13
-->
<template>
<div id="page">
    
    <!-- header and footer bar go here-->
    <div class="header header-fixed header-auto-show header-logo-app">
        <a href="#" data-back-button class="header-title header-subtitle">Back</a>
        <a href="#" data-back-button class="header-icon header-icon-1"><i class="fas fa-arrow-left"></i></a>
        <a href="#" data-toggle-theme class="header-icon header-icon-3 show-on-theme-dark"><i class="fas fa-sun"></i></a>
        <a href="#" data-toggle-theme class="header-icon header-icon-3 show-on-theme-light"><i class="fas fa-moon"></i></a>
        <a href="#" data-menu="menu-main" class="header-icon header-icon-2"><i class="fas fa-bars"></i></a>
    </div>

    <div class="page-content pb-0">
        <div class="page-title page-title-small">
            <h2><a href="#" data-back-button><i class="fa fa-arrow-left"></i></a>Zákazník</h2>
            <a href="#" data-menu="menu-main" class="bg-fade-highlight-light shadow-xl preload-img" data-src="images/avatars/5s.png"></a>
        </div>
        <div class="card header-card shape-rounded" data-card-height="150">
            <div class="card-overlay bg-highlight opacity-95"></div>
            <div class="card-overlay dark-mode-tint"></div>
            <div class="card-bg preload-img" data-src="images/pictures/20s.jpg"></div>
        </div>

        <div class="content" style="margin-top: 75px;">
            <div class="row mb-0">
                <router-link to="database" class="col-4">
                    <div class="card card-style text-center py-3 mx-0 mb-0">
                      <h3 class="mt-2 font-24 mb-0">{{ customer.points }}</h3>
                      <p class="font-13 font-500 mb-n1 mt-0 color-theme">bodov</p>
                    </div>
                </router-link>
                <div @click="$feather();editCustomer = true" v-if="!editCustomer" class="col-4 pointer">
                    <div class="card card-style text-center py-3 mx-0 mb-0">
                      <i data-feather="edit" data-feather-line="1" data-feather-size="24" data-feather-color="blue-dark" data-feather-bg="blue-fade-light" class="m-auto"></i>
                      <p v-if="editCustomer !== true" class="font-13 font-500 mb-n1 mt-2 color-theme">Editovať</p>
                    </div>
                </div>
                <div @click="saveCustomer();" v-if="editCustomer" class="col-4 pointer">
                    <div class="card card-style text-center py-3 mx-0 mb-0">
                      <i data-feather="save" data-feather-line="1" data-feather-size="24" data-feather-color="green-dark" data-feather-bg="green-fade-light" class="m-auto"></i>
                      <p class="font-13 font-500 mb-n1 mt-2 color-theme">Uložiť</p>
                    </div>
                </div>
                <div @click="openConfirmModal()" to="customers" v-if="!editCustomer && !customer.deletedTime" class="col-4">
                    <div class="card card-style text-center py-3 mx-0 mb-0">
                      <i data-feather="trash" data-feather-line="1" data-feather-size="24" data-feather-color="red-dark" data-feather-bg="red-fade-light" class="m-auto"></i>
                      <p class="font-13 font-500 mb-n1 mt-2 color-theme">Zmazať</p>
                    </div>
                </div>
                <div @click="undeleteCustomer(); $feather(); editCustomer = false" v-if="!editCustomer && customer.deletedTime" class="col-4">
                    <div class="card card-style text-center py-3 mx-0 mb-0">
                      <i data-feather="rewind" data-feather-line="1" data-feather-size="24" data-feather-color="red-dark" data-feather-bg="red-fade-light" class="m-auto"></i>
                      <p class="font-13 font-500 mb-n1 mt-2 color-theme">Obnoviť</p>
                    </div>
                </div>
                <div @click="getCustomer(); $feather(); editCustomer = false" v-if="editCustomer" class="col-4">
                    <div class="card card-style text-center py-3 mx-0 mb-0">
                      <i data-feather="rewind" data-feather-line="1" data-feather-size="24" data-feather-color="red-dark" data-feather-bg="red-fade-light" class="m-auto"></i>
                      <p class="font-13 font-500 mb-n1 mt-2 color-theme">Zrušiť</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- name card -->
        <div class="card card-style">
          <div class="content">
            <div class="d-flex mb-2">
              <div>
                <h2 class="mb-2 pt-1 text-uppercase">{{ customer.name }}</h2>
                <div v-if="customer.updatedTime" class="badge-number bg-blue-light">Upravený</div>
                <div v-if="customer.addedTime" class="badge-number bg-green-light">Nový</div>
                <div v-if="customer.deletedTime" class="badge-number bg-red-light">Zmazaný</div>
              </div>
            </div>
            <p>
              Zákazníka môžete editovať a uložiť zmeny, ktoré budú odoslané po synschronizácií.
            </p>
            <div class="input-style has-borders no-icon input-style-always-active validate-field">
              <input type="text" class="form-control read-only validate-text bg-white" id="form2" placeholder="-" v-model="customer.name" :readonly="!editCustomer">
              <label for="form2" class="grey-light">Názov</label>
              <i class="fa fa-times disabled invalid color-red-dark"></i>
              <i class="fa fa-check disabled valid color-green-dark"></i>
              <em v-if="editCustomer">(povinné)</em>
            </div>
            <div class="input-style has-borders no-icon input-style-always-active validate-field">
              <input type="number" class="form-control read-only validate-text bg-white" id="form3" placeholder="-" :value="customer.id" :readonly="!editCustomer">
              <label for="form3" class="grey-light">Číslo</label>
              <i class="fa fa-times disabled invalid color-red-dark"></i>
              <i class="fa fa-check disabled valid color-green-dark"></i>
              <em v-if="editCustomer">(povinné)</em>
            </div>
            <div class="input-style has-borders no-icon input-style-always-active validate-field">
              <input type="number" class="form-control read-only validate-text bg-white" id="form3" placeholder="-" :value="customer.idOz" :readonly="!editCustomer">
              <label for="form3" class="grey-light">Číslo OZ</label>
              <i class="fa fa-times disabled invalid color-red-dark"></i>
              <i class="fa fa-check disabled valid color-green-dark"></i>
              <em v-if="editCustomer">(povinné)</em>
            </div>
            <div class="input-style has-borders no-icon input-style-always-active validate-field">
              <input type="text" class="form-control read-only validate-text bg-white" id="form2" placeholder="-" :value="customer.pzsCode" :readonly="!editCustomer">
              <label for="form2" class="grey-light">PZS kód</label>
              <i class="fa fa-times disabled invalid color-red-dark"></i>
              <i class="fa fa-check disabled valid color-green-dark"></i>
              <em v-if="editCustomer">(povinné)</em>
            </div>
          </div>
        </div>

        <!-- additional info card -->
        <div class="card card-style">
          <div class="content">
            <h3 class="mb-2">Doplňujúce informácie</h3>
            <div v-if="customer.updatedTime" class="badge-number bg-blue-light">Upravený</div>
            <div v-if="customer.addedTime" class="badge-number bg-green-light">Nový</div>
            <div v-if="customer.deletedTime" class="badge-number bg-red-light">Zmazaný</div>
            <p>
              Ďalšie Doplňujúce informácie o zákazníkovi, ako názov reťazca a názov združenia, ktorých je členom.
            </p>
            <div class="input-style has-borders no-icon input-style-always-active validate-field">
              <input type="text" class="form-control read-only validate-text bg-white" id="form2" placeholder="-" :value="customer.addName" :readonly="!editCustomer">
              <label for="form2" class="grey-light">Doplnok k názvu</label>
              <i class="fa fa-times disabled invalid color-red-dark"></i>
              <i class="fa fa-check disabled valid color-green-dark"></i>
              <em v-if="editCustomer">(povinné)</em>
            </div>
            <div class="input-style has-borders no-icon input-style-always-active validate-field">
              <input type="text" class="form-control read-only validate-text bg-white" id="form2" placeholder="-" :value="customer.networkName" :readonly="!editCustomer">
              <label for="form2" class="grey-light">Názov reťazca</label>
              <i class="fa fa-times disabled invalid color-red-dark"></i>
              <i class="fa fa-check disabled valid color-green-dark"></i>
              <em v-if="editCustomer">(povinné)</em>
            </div>
            <div class="input-style has-borders no-icon input-style-always-active validate-field">
              <input type="text" class="form-control read-only validate-text bg-white" id="form2" placeholder="-" :value="customer.associationName" :readonly="!editCustomer">
              <label for="form2" class="grey-light">Názov združenia</label>
              <i class="fa fa-times disabled invalid color-red-dark"></i>
              <i class="fa fa-check disabled valid color-green-dark"></i>
              <em v-if="editCustomer">(povinné)</em>
            </div>
          </div>
        </div>

        <!-- contact card -->
        <div class="card card-style">
          <div class="content">
            <h3 class="mb-2">Kontakt</h3>
            <div v-if="customer.updatedTime" class="badge-number bg-blue-light">Upravený</div>
            <div v-if="customer.addedTime" class="badge-number bg-green-light">Nový</div>
            <div v-if="customer.deletedTime" class="badge-number bg-red-light">Zmazaný</div>
            <p>
              Kontaktné informácie na spoločnosť.
            </p>
            <div class="input-style has-borders no-icon input-style-always-active validate-field">
              <input type="text" class="form-control read-only validate-text bg-white" id="form2" placeholder="-" :value="customer.leader" :readonly="!editCustomer">
              <label for="form2" class="grey-light">Meno vedúceho</label>
              <i class="fa fa-times disabled invalid color-red-dark"></i>
              <i class="fa fa-check disabled valid color-green-dark"></i>
              <em v-if="editCustomer">(povinné)</em>
            </div>
            <div class="input-style has-borders no-icon input-style-always-active validate-field">
              <input type="phone" class="form-control read-only validate-text bg-white" id="form2" placeholder="-" :value="customer.phone" :readonly="!editCustomer">
              <label for="form2" class="grey-light">Telefón</label>
              <i class="fa fa-times disabled invalid color-red-dark"></i>
              <i class="fa fa-check disabled valid color-green-dark"></i>
              <em v-if="editCustomer">(povinné)</em>
            </div>
            <div class="input-style has-borders no-icon input-style-always-active validate-field">
              <input type="email" class="form-control read-only validate-text bg-white" id="form2" placeholder="-" :value="customer.email" :readonly="!editCustomer">
              <label for="form2" class="grey-light">Email</label>
              <i class="fa fa-times disabled invalid color-red-dark"></i>
              <i class="fa fa-check disabled valid color-green-dark"></i>
              <em v-if="editCustomer">(povinné)</em>
            </div>
            <div class="input-style has-borders no-icon input-style-always-active validate-field">
              <input type="phone" class="form-control read-only validate-text bg-white" id="form2" placeholder="-" :value="customer.fax" :readonly="!editCustomer">
              <label for="form2" class="grey-light">Fax</label>
              <i class="fa fa-times disabled invalid color-red-dark"></i>
              <i class="fa fa-check disabled valid color-green-dark"></i>
              <em v-if="editCustomer">(povinné)</em>
            </div>
            <div class="input-style has-borders no-icon input-style-always-active validate-field">
              <input type="text" class="form-control read-only validate-text bg-white" id="form2" placeholder="-" :value="customer.orderedBy" :readonly="!editCustomer">
              <label for="form2" class="grey-light">Objednávajúci</label>
              <i class="fa fa-times disabled invalid color-red-dark"></i>
              <i class="fa fa-check disabled valid color-green-dark"></i>
              <em v-if="editCustomer">(povinné)</em>
            </div>
            <div class="d-flex">
              <div class="align-self-center m-auto">
                <a :href="'tel:' + customer.phone" target="_blank" class="external-link btn btn-center-m btn-sm rounded-s text-uppercase font-900 bg-green-light" style="max-width: calc(100% - 20px);">Zavolať</a>
              </div>
              <div class="align-self-center m-auto">
                <a :href="'mailto:' + customer.email" target="_blank" class="external-link btn btn-center-m btn-sm rounded-s text-uppercase font-900 bg-blue-light" style="max-width: calc(100% - 20px);">E-Mail</a>
              </div>
            </div>
          </div>
        </div>

        <!-- address card -->
        <div class="card card-style">
          <div class="content">
            <h3 class="mb-2">Adresa</h3>
            <div v-if="customer.updatedTime" class="badge-number bg-blue-light">Upravený</div>
            <div v-if="customer.addedTime" class="badge-number bg-green-light">Nový</div>
            <div v-if="customer.deletedTime" class="badge-number bg-red-light">Zmazaný</div>
            <p>
              Jedná sa o dodaciu adresu zákazníka.
            </p>
            <div class="input-style has-borders no-icon input-style-always-active validate-field">
              <input type="text" class="form-control read-only validate-text bg-white" id="form2" placeholder="-" :value="customer.street" :readonly="!editCustomer">
              <label for="form2" class="grey-light">Ulica</label>
              <i class="fa fa-times disabled invalid color-red-dark"></i>
              <i class="fa fa-check disabled valid color-green-dark"></i>
              <em v-if="editCustomer">(povinné)</em>
            </div>
            <div class="input-style has-borders no-icon input-style-always-active validate-field">
              <input type="text" class="form-control read-only validate-text bg-white" id="form3" placeholder="-" :value="customer.town" :readonly="!editCustomer">
              <label for="form3" class="grey-light">Mesto</label>
              <i class="fa fa-times disabled invalid color-red-dark"></i>
              <i class="fa fa-check disabled valid color-green-dark"></i>
              <em v-if="editCustomer">(povinné)</em>
            </div>
            <div class="input-style has-borders no-icon input-style-always-active validate-field">
              <input type="text" class="form-control read-only validate-text bg-white" id="form3" placeholder="-" :value="customer.city" :readonly="!editCustomer">
              <label for="form3" class="grey-light">Mestská časť</label>
              <i class="fa fa-times disabled invalid color-red-dark"></i>
              <i class="fa fa-check disabled valid color-green-dark"></i>
              <em v-if="editCustomer">(povinné)</em>
            </div>
            <div class="input-style has-borders no-icon input-style-always-active validate-field">
              <input type="number" class="form-control read-only validate-text bg-white" id="form3" placeholder="-" :value="customer.psc" :readonly="!editCustomer">
              <label for="form3" class="grey-light">PSČ</label>
              <i class="fa fa-times disabled invalid color-red-dark"></i>
              <i class="fa fa-check disabled valid color-green-dark"></i>
              <em v-if="editCustomer">(povinné)</em>
            </div>
          </div>
        </div>

        <!-- tax card -->
        <div class="card card-style">
          <div class="content">
            <h3 class="mb-2">Daňové informácie</h3>
            <div v-if="customer.updatedTime" class="badge-number bg-blue-light">Upravený</div>
            <div v-if="customer.addedTime" class="badge-number bg-green-light">Nový</div>
            <div v-if="customer.deletedTime" class="badge-number bg-red-light">Zmazaný</div>
            <p>
              Informácie potrebné pre daňové potreby.
            </p>
            <div class="input-style has-borders no-icon input-style-always-active validate-field">
              <input type="number" class="form-control read-only validate-text bg-white" id="form2" placeholder="-" :value="customer.ico" :readonly="!editCustomer">
              <label for="form2" class="grey-light">IČO</label>
              <i class="fa fa-times disabled invalid color-red-dark"></i>
              <i class="fa fa-check disabled valid color-green-dark"></i>
              <em v-if="editCustomer">(povinné)</em>
            </div>
            <div class="input-style has-borders no-icon input-style-always-active validate-field">
              <input type="number" class="form-control read-only validate-text bg-white" id="form2" placeholder="-" :value="customer.dic" :readonly="!editCustomer">
              <label for="form2" class="grey-light">DIČ / IČO DPH</label>
              <i class="fa fa-times disabled invalid color-red-dark"></i>
              <i class="fa fa-check disabled valid color-green-dark"></i>
              <em v-if="editCustomer">(povinné)</em>
            </div>
          </div>
        </div>

        <!-- transfer centers -->
        <div class="card card-style">
          <div class="content">
            <h3 class="mb-2">Transferové centrá</h3>
            <div v-if="customer.updatedTime" class="badge-number bg-blue-light">Upravený</div>
            <div v-if="customer.addedTime" class="badge-number bg-green-light">Nový</div>
            <div v-if="customer.deletedTime" class="badge-number bg-red-light">Zmazaný</div>
            <p>
              Informácie ohľadne transferových centier a čísielníky v nich.
            </p>
            <div class="input-style has-borders no-icon input-style-always-active validate-field">
              <input type="number" class="form-control read-only validate-text bg-white" id="form2" placeholder="-" :value="customer.tcIdPhoenix" :readonly="!editCustomer">
              <label for="form2" class="grey-light">Phoenix</label>
              <i class="fa fa-times disabled invalid color-red-dark"></i>
              <i class="fa fa-check disabled valid color-green-dark"></i>
              <em v-if="editCustomer">(povinné)</em>
            </div>
            <div class="input-style has-borders no-icon input-style-always-active validate-field">
              <input type="number" class="form-control read-only validate-text bg-white" id="form2" placeholder="-" :value="customer.tcIdUnipharma" :readonly="!editCustomer">
              <label for="form2" class="grey-light">Unipharma</label>
              <i class="fa fa-times disabled invalid color-red-dark"></i>
              <i class="fa fa-check disabled valid color-green-dark"></i>
              <em v-if="editCustomer">(povinné)</em>
            </div>
            <div class="input-style has-borders no-icon input-style-always-active validate-field">
              <input type="number" class="form-control read-only validate-text bg-white" id="form2" placeholder="-" :value="customer.tcIdMedart" :readonly="!editCustomer">
              <label for="form2" class="grey-light">MED-ART</label>
              <i class="fa fa-times disabled invalid color-red-dark"></i>
              <i class="fa fa-check disabled valid color-green-dark"></i>
              <em v-if="editCustomer">(povinné)</em>
            </div>
            <div class="input-style has-borders no-icon input-style-always-active validate-field">
              <input type="number" class="form-control read-only validate-text bg-white" id="form2" placeholder="-" :value="customer.tcIdUnimed" :readonly="!editCustomer">
              <label for="form2" class="grey-light">Unimed</label>
              <i class="fa fa-times disabled invalid color-red-dark"></i>
              <i class="fa fa-check disabled valid color-green-dark"></i>
              <em v-if="editCustomer">(povinné)</em>
            </div>
          </div>
        </div>

        <!-- save card -->
        <div v-if="editCustomer === true" class="card card-style">
          <div class="content">
            <h3 class="mb-2">Uložiť</h3>
            <div v-if="customer.updatedTime" class="badge-number bg-blue-light">Upravený</div>
            <div v-if="customer.addedTime" class="badge-number bg-green-light">Nový</div>
            <div v-if="customer.deletedTime" class="badge-number bg-red-light">Zmazaný</div>
            <p class="mb-2">
              Po uložení budú dáta označené na synchronizáciu a pri najbližšom odoslaní budú poslané na servery Dr Theiss.
            </p>
            <div @click="saveCustomer()" class="btn btn-m mb-2 btn-full bg-highlight rounded-sm text-uppercase font-900"><i class="i-loading fa fa-sync fa-spin me-3"></i>uložiť</div>
            <div @click="getCustomer(); $feather(); editCustomer = false" class="btn btn-m mb-2 btn-full color-black rounded-sm text-uppercase font-900"><i class="i-loading fa fa-sync fa-spin me-3"></i>zrušiť zmeny</div>
          </div>
        </div>

        <div class="card card-style">
          <div class="content">
              <h3 class="float-start">Posledné objednávky</h3>
              <a class="float-end font-12 color-highlight mt-n1" href="orders.html">Všetky</a>
              <div class="clearfix"></div>
              <p>
                Zoznam posledných objednávok zákazníka.
              </p>
              <div class="d-flex">
                  <div>
                    <a href="#" class="icon icon-m bg-highlight rounded-m shadow-xl"><i class="fa fa-arrow-up"></i></a>
                  </div>
                  <div class="align-self-center ps-3">
                      <h5 class="font-600 font-14 mb-n2">Vilten s.r.o.</h5>
                      <span class="color-theme font-11">distr. MED-ART</span>
                  </div>
                  <div class="align-self-center ms-auto">
                    <h5 class="color-highlight mb-n1 text-end">$12.350</h5>
                    <span class="color-theme d-block font-11 text-end">Jul 15th</span>
                  </div>
              </div>
              <div class="divider mt-3 mb-3"></div>
              <div class="d-flex">
                  <div>
                    <a href="#" class="icon icon-m bg-highlight rounded-m shadow-xl"><i class="fa fa-arrow-up"></i></a>
                  </div>
                  <div class="align-self-center ps-3">
                      <h5 class="font-600 font-14 mb-n2">Smarter Group s.r.o.</h5>
                      <span class="color-theme font-11">distr. PHOENIX</span>
                  </div>
                  <div class="align-self-center ms-auto">
                      <h5 class="color-highlight mb-n1 text-end">$12.350</h5>
                      <span class="color-theme d-block font-11 text-end">Jul 15th</span>
                  </div>
              </div>
              <div class="divider mt-3 mb-3"></div>
              <div class="d-flex">
                  <div>
                      <a href="#" class="icon icon-m bg-green-dark rounded-m shadow-xl"><i class="fa fa-euro-sign font-20"></i></a>
                  </div>
                  <div class="align-self-center ps-3">
                      <h5 class="font-600 font-14 mb-n2">Lekáreň Leonardo</h5>
                      <span class="color-theme font-11">distr. UNIMED</span>
                  </div>
                  <div class="align-self-center ms-auto">
                    <h5 class="color-green-dark mb-n1 text-end">$12.350</h5>
                    <span class="color-theme d-block font-11 text-end">Jul 15th</span>
                  </div>
              </div>
          </div>
        </div>

        <!-- back to top -->
        <div class="content mt-5 mb-5">
          <a href="#" class="back-to-top-badge bg-highlight shadow-xl"><i class="fa fa-caret-up"></i><span>Back to Top</span></a>
        </div>
        <!-- footer and footer card-->
    </div>    
    <!-- end of page content-->
    
    <!-- menu pin warning -->
    <div id="menu-pin-warning" class="menu menu-box-modal rounded-m" 
         data-menu-height="310"
         data-menu-width="310">
      <h1 class="text-center mt-3 pt-1"><i class="fa fa-3x fa-times color-red-dark"></i></h1>
      <h1 class="text-center mt-3 font-700">Nesprávny PIN!</h1>
      <p id="error_text" class="boxed-text-l">
        Zadaný PIN je nesprávny. Prosím, zopakujte proces ešte raz.
      </p>
      <a href="#" class="close-menu btn btn-m btn-center-m button-s shadow-l rounded-s text-uppercase font-900 bg-red-light">OPAKOVAŤ</a>
    </div>   

    <main-menu />
    
    <error-modal v-model="errorMesage" />
    <success-modal :message="successMesage" :title="successTitle" />
    <confirm-modal title="Naozaj vymazať?" message="Chcete naozaj označiť tohto zákazníka na vymazanie?" @onConfirm="deleteCustomer()" />

</div>
</template>

<script>
import { ref, inject } from 'vue'
import MainMenu from '@/components/menus/MainMenu'
import ErrorModal from '@/components/modals/ErrorModal'
import SuccessModal from '@/components/modals/SuccessModal'
import storage from '@/lib/storage'
import ConfirmModal from '@/components/modals/ConfirmModal.vue'

export default {
  name: 'CustomerDetail',
  components: {
    MainMenu,
    ErrorModal,
    SuccessModal,
    ConfirmModal
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const errorMesage = ref('')
    const successMesage = ref('')
    const successTitle = ref('')
    const editCustomer = ref(false)
    const customer = ref({})

    const appProps = inject('appProps')

    function getCustomer() {
      storage.getCustomer(props.id)
        .then(data => {
          customer.value = data || {}
        })
        .finally(() => {
          // loading.value = false
        })
    }

    function saveCustomer () {
      storage.updateCustomer(customer.value)
        .then(() => {
          editCustomer.value = false;
          appProps.$feather()
          successTitle.value = 'Uložené'
          successMesage.value = 'Zmeny na zákazníkovi boli úspešne uložené.'
          errorMesage.value = ''
          appProps.$openSuccessModal()
        })
        .catch(error => {
          successTitle.value = ''
          successMesage.value = ''
          errorMesage.value = error
          appProps.$openErrorModal()
        })
    }

    function deleteCustomer () {
      storage.deleteCustomer(customer.value)
      .then(() => {
          customer.value.deletedTime = Date.now()
          editCustomer.value = false;
          appProps.$feather()
          successTitle.value = 'Zmazané'
          successMesage.value = 'Zákazník bol nastavený na zmazanie a pri najbližšej synchronizácií bude odstránený.'
          errorMesage.value = ''
          setTimeout(() => {
            appProps.$openSuccessModal()
          }, 100)
        })
        .catch(error => {
          successTitle.value = ''
          successMesage.value = ''
          errorMesage.value = error
          appProps.$openErrorModal()
        })
    }

    function undeleteCustomer () {
      storage.undeleteCustomer(customer.value)
      .then(() => {
          customer.value.deletedTime = undefined
          editCustomer.value = false;
          appProps.$feather()
          successTitle.value = 'Obnovené'
          successMesage.value = 'Zákazníkovi bol odstránený príkaz na vymazanie.'
          errorMesage.value = ''
          setTimeout(() => {
            appProps.$openSuccessModal()
          }, 100)
        })
        .catch(error => {
          successTitle.value = ''
          successMesage.value = ''
          errorMesage.value = error
          appProps.$openErrorModal()
        })
    }

    function openConfirmModal() {
      appProps.$openConfirmModal()
    }

    return {
      errorMesage,
      successMesage,
      successTitle,
      editCustomer,
      customer,
      getCustomer,
      saveCustomer,
      deleteCustomer,
      undeleteCustomer,
      openConfirmModal
    }
  },
  mounted() {
    setTimeout(() => {
      document.init_event()
    })
    this.getCustomer()
  }
}
</script>

<style>

</style>